import { Skeleton, Flex, Heading, Spacer, Box } from '@chakra-ui/react';
import React from 'react';

import { AssignmentEditStrategyContainer } from './AssignmentEditStrategyContainer';
import { useLatestAssignmentPipelineRunMetadataForImplementationContext } from 'packages/loanProduct/hooks/LatestAssignmentPipelineRunMetadataForImplementationProvider';
import { PipelineStatusAlert } from 'packages/loanProduct/ui/v2/PipelineStatusAlert';

export const AssignmentApplyStrategyContainer = () => {
  const {
    metadata,
  } = useLatestAssignmentPipelineRunMetadataForImplementationContext();

  if (!metadata) {
    return <Skeleton w="100%" h="100%" />;
  }

  return (
    <Box height="100%">
      {(() => {
        if (metadata === undefined) {
          return <Skeleton h="25%" />;
        }
        if (!metadata || metadata.status !== 'success') {
          return (
            <>
              <Flex justify="space-between" mb="24px">
                <Heading as="h2">Apply Strategy</Heading>
                <Spacer />
              </Flex>
              <PipelineStatusAlert
                status={metadata ? metadata.status : 'noPipelineRun'}
              />
            </>
          );
        }
        return <AssignmentEditStrategyContainer readOnly />;
      })()}
    </Box>
  );
};
